module.exports = __webpack_public_path__ + "static/AdobeStock_349044023_80-c13684f867d68c618259d0a4bb39eec1.jpg";